import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73a4ecaf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a4ecaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a4ecaf')) {
      api.createRecord('73a4ecaf', component.options)
    } else {
      api.reload('73a4ecaf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=73a4ecaf&scoped=true", function () {
      api.rerender('73a4ecaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/logistics/company/postcode/index.vue"
export default component.exports